export const default_chatbot = {
  data:{
    welcomeText: "",
    topic: "",
    communicationLayers: [{ type: "", statement: "" }],
  },
  time:null
};



// WEBPACK FOOTER //
// ./src/screens/AutoConcierge/constants/default.js